import { Group, Vector3, Geometry, LineSegments, WireframeGeometry, LineBasicMaterial, Color, BufferGeometry, BufferAttribute, Line } from 'three';
import { TWEEN } from 'three/examples/jsm/libs/tween.module.min.js';

class Flower extends Group {
    constructor(parent) {
        // Call parent Group() constructor
        super();

        this.name = "shot";

        var geometry1 = new Geometry();
        //const l1 = new Vector3(0.0, 0.0, 14.0);
        geometry1.vertices.push(new Vector3(0.0, 0.0, 0.0));
        geometry1.vertices.push(new Vector3(0.0, 0.0, 14.0));

        var geometry2 = new Geometry();
        geometry2.vertices.push(new Vector3(2.0, 0.0, 14.0));
        geometry2.vertices.push(new Vector3(0.0, 2.0, 14.0));
        geometry2.vertices.push(new Vector3(-2.0, 0.0, 14.0));
        geometry2.vertices.push(new Vector3(0.0, -2.0, 14.0));
        geometry2.vertices.push(new Vector3(2.0, 0.0, 14.0));

        const material1 = new LineBasicMaterial( {
	          color: new Color("rgb(255, 150, 100)"),
	          linewidth: 10,
            opacity: 1,
            transparent: true,
	          linecap: 'round', //ignored by WebGLRenderer
	          linejoin:  'round' //ignored by WebGLRenderer
        } );

        const line1 = new Line(geometry1, material1 );
        const line2 = new Line(geometry2, material1.clone() );
        //line1.visible = false;


        // Init state
        this.state = {
            line1: line1,
            line2: line2,
            timer1: -1.0,
            impact: new Vector3(0,0,0),
        };

        this.add( line1);
        this.add(line2);
        line2.visible = false;
        line2.material.transparent = true;
        line2.scale.set(.1,.1,.1);
        // Add self to parent's update list
        parent.addToUpdateList(this);
    }

    update(timeStamp) {
        
        if(this.position.distanceTo(this.state.impact)<14){
            this.state.line1.visible = false;
            this.state.line2.visible = true;
            if (this.state.line2.material.opacity > 0){
                this.state.line2.material.opacity -= 0.1;
                this.state.line2.scale.add(new Vector3(.1,.1,.1));
            }
        }
        else this.translateZ(6);
    }
}


export default Flower;
